import { createContext, useContext } from "react";

/**
 * Identifies which `CuadraRuntimeProvider` / `CuadraChat` instance produced a
 * surfaced error so global pub/sub stores (e.g. attachment errors) do not leak
 * across multiple mounted widgets.
 */
export const CuadraErrorSurfaceContext = createContext<string>("");

export function useCuadraErrorSurfaceId(): string {
  return useContext(CuadraErrorSurfaceContext);
}
